<template>
  <div class="foters">
    <div class="form">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="客户姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入客户姓名"
                v-model="conditionLike.custName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="手机号码"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入手机号码"
                :allowClear="true"
                v-model="conditionLike.phoneNo"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fw">
            <a-form-item
              label="审核状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                :allowClear="true"
                v-model="conditionLike.custStatus"
                placeholder="请选择审核状态"
              >
                <a-select-option
                  v-for="item in usrTpList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="padding-top: 2.4%; margin-left: 12px">
              <a-button class="btone" @click="queryList(1)">查询</a-button>
              <a-button class="bttwo" @click="userAdd()">批量审核</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <div>
        <a-table
          :columns="columns"
          :scroll="{ x: 1000, y: 'calc(100vh - 340px)' }"
          :data-source="tableData"
          :pagination="false"
          :loading="Tableloading"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
            columnWidth: 40,
          }"
          :rowKey="
            (record, index) => {
              return record.id;
            }
          "
          bordered
          size="small"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + (pageNum - 1) * pageSize + 1 }}
          </span>
          <span slot="custStatus" slot-scope="text, record">
            <span v-if="record.custStatus == 3"><a-badge color="cyan" /></span>
            <span v-else-if="record.custStatus == 2"
              ><a-badge color="orange"
            /></span>
            <span v-else-if="record.custStatus == 4"
              ><a-badge color="red"
            /></span>
            <span v-else-if="record.custStatus == 1"
              ><a-badge color="orange"
            /></span>
            {{ record.custStatus | DictionaryFilter("CUST_STATUS") }}
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ toDate(record.createTime) }}
          </span>
          <span slot="comments" slot-scope="text, record">
            <span v-if="record.custStatus == 4" style="color: red">{{
              text
            }}</span>
            <span v-else> {{ text }}</span>
          </span>
          <div slot="action" slot-scope="text">
            <a-dropdown>
              <a-menu
                slot="overlay"
                style="text-align: center"
              >
                <a-menu-item key="1">
                  <a
                    href="javascript:;"
                    class="modification"
                    @click="modificatePass(text)"
                    >通过</a
                  ></a-menu-item
                >
                <a-menu-item key="2">
                  <a
                    href="javascript:;"
                    class="modification"
                    @click="modificateRefuse(text)"
                    >拒绝</a
                  >
                </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px" class="btaction">
                更多操作 <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </div>

        </a-table>
      </div>
      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPage }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :current="pageNum"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <addModal
      v-if="visibleAdd"
      :visible="visibleAdd"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></addModal>
    <batchModal
      v-if="visibleBatch"
      :visible="visibleBatch"
      :userData="userData"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></batchModal>
  </div>
</template>

<script>
import { queryRegisterCus } from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import addModal from "./register-modal.vue";
import batchModal from "./register-batch-modal";
export default {
  name: "userManagement",
  components: {
    addModal: addModal,
    batchModal: batchModal,
  },
  data() {
    return {
      formLayout: "horizontal",
      conditionLike: {
        phoneNo: "",
        custName: "",
        custStatus: undefined,
      },
      Tableloading: false,
      usrTpList: [],
      tableData: [],
      selectedRowKeys: [],
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 40,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "客户账号",
          align: "center",
          dataIndex: "custCode",
          width: 100,
          key: "custCode",
          ellipsis: true,
          scopedSlots: { customRender: "custCode" },
        },
        {
          title: "客户姓名",
          align: "center",
          dataIndex: "custName",
          width: 100,
          key: "custName",
          ellipsis: true,
          scopedSlots: { customRender: "custName" },
        },
        {
          title: "手机号码",
          align: "center",
          dataIndex: "phoneNo",
          width: 100,
          key: "phoneNo",
          ellipsis: true,
        },
        {
          title: "审核状态",
          align: "center",
          dataIndex: "custStatus",
          width: 70,
          key: "custStatus",
          ellipsis: true,
          scopedSlots: { customRender: "custStatus" },
        },
        {
          title: "注册日期",
          align: "center",
          dataIndex: "createTime",
          width: 100,
          key: "createTime",
          ellipsis: true,
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "审核意见",
          align: "center",
          dataIndex: "comments",
          width: 100,
          key: "comments",
          ellipsis: true,
          scopedSlots: { customRender: "comments" },
        },

        {
          title: "操作",
          align: "center",
          key: "action",
          width: 90,
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      // // 分页相关
      pageNum: 1,
      pageSize: 10,
      totalRows: null,
      totalPage: "",
      //新增弹框
      visibleAdd: false,
      visibleBatch: false,
      userData: {},
      type: "",
    };
  },
  activated() {
    //查询数据字典
    DictionaryService.getAllNeedDic(["CUST_STATUS"]).then((res) => {
      this.usrTpList = DictionaryService.getOptions("CUST_STATUS");
      //查询列表
      this.queryList(1);
    });
  },
  mounted() {},
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 分页修改
    changePageFn(event) {
      this.pageNum = event;

      this.queryList();
    },
    toDate(date) {
      if (date == null) {
        return "";
      } else {
        let date1 = new Date(date);
        let time = this.formatDate(date1);
        return time;
      }
    },
    formatDate(value) {
      if (value == null) {
        return "";
      } else {
        const date = new Date(value);
        const y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        let h = date.getHours(); // 时
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes(); // 分
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
    // 获取表格数据
    queryList(sum = 2) {
      if (sum == 1) this.pageNum = 1;
      this.Tableloading = true;
      let pageParam = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderBy: "",
      };
      queryRegisterCus({
        pageParam: pageParam,
        content: this.conditionLike,
      }).then(
        (res) => {
          this.Tableloading = false;
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPage = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {
          this.$message.error("查询失败");
          this.Tableloading = false;
        }
      );
    },
    // 用户新增
    userAdd() {
      if (this.selectedRowKeys.length > 0) {
        this.visibleBatch = true;
        this.userData = this.selectedRowKeys;
        this.title = "批量审核";
      } else {
        this.$message.warning("请先选择");
      }
    },
    // 关闭弹窗
    reflush(value) {
      this.visibleAdd = value;
      this.visibleBatch = value;
      this.selectedRowKeys = [];
    },
    //更多操作-通过
    modificatePass(data) {
      this.visibleAdd = true;
      this.type = "pass";
      this.userData = data;
      this.title = "审批通过";
    },
    //更多操作-拒绝
    modificateRefuse(data) {
      this.visibleAdd = true;
      this.type = "refuse";
      this.userData = data;
      this.title = "审批拒绝";
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.foters {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 100px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 12px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  a {
    margin-left: 10px;
    color: #108ee9;
  }
  a:hover {
    color: #70b9cf;
  }
}

/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/deep/ .form .ant-input,
.ant-select,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 236px;
}
.oper {
  width: 300px;
}
.plan {
  width: 350px;
}
.ant-row {
  display: flex;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 75px;
}
/deep/ .ant-col-18 {
  width: 75%;
}
</style>
